import BemIt from "@gtechdoodler/bem-it";
import Icon from "../../../../../imagery/Icon";
import Typography from "../../../../../typography/Typography";
import SelectableFragment from "../ListItemSelectableFragment/ListItemSelectableFragment";
import Snippet from "../ListItemSnippet/ListItemSnippet";
import { ListItemTextSnippetProps } from "./ListItemTextSnippet.types";

const ListItemTextSnippet: React.FC<ListItemTextSnippetProps> = ({
	iconName,
	selected,
	text,
}) => {
	const block = new BemIt("ListItemTextSnippet");
	return (
		<Snippet className={block.out}>
			<SelectableFragment selected={selected}>
				{iconName && <Icon name={iconName} size="md" />}
				<Typography weight="regular" flexGrow={1}>
					{text}
				</Typography>
			</SelectableFragment>
		</Snippet>
	);
};

export default ListItemTextSnippet;
